import React, { useEffect, useState } from 'react'
import ApiHandler from '../../../ApiHandler'
import GlobalVariable from '../../../GlobalVariable'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons'

export const ProductImgDetail = ({ productCode }) => {


    const [productImage, setProductImage] = useState({
        image: "",
        descriptions: "",
    })


    const loadApi = () => {
        setShow(true);
        ApiHandler.post({
            url: `api/Search/ProductInfo?wClientId=${GlobalVariable.wcClient}&prodCode=${productCode}`,
            data: {
            }
        })
            .then((result) => {
                console.log(result.data)
                setProductImage({
                    image: result.data.imageUrl,
                    descriptions: result.data.description
                })
            })
            .catch(err => {
                console.error(err);
            })
    }

    const [show, setShow] = useState(false);

    const showImage = () => {
        if (productImage.image) {
            return <><img src={productImage.image} alt="Product" className="product-image"
                style={{
                    maxWidth: 300
                }}
            />
                <div dangerouslySetInnerHTML={{ __html: productImage.descriptions }} />
            </>
        }
        return <div className="no-image">No Image Available</div>
    }

    return (
        <div className='  '><br />
            <FontAwesomeIcon icon={faCircleInfo} className="product-image-icon" role='button' onClick={loadApi} />
            {show && showImage()}
        </div>
    )
}
